import { useMemo } from 'react'
import { useResourceTypeIdsQuery } from 'src/api/api.generated'

export const useHourlyResourceTypeCheck = (tenantId: string, propertyId: string) => {
  const query = useResourceTypeIdsQuery({
    variables: {
      filter: {
        tenantId: { eq: tenantId },
        propertyId: { eq: propertyId },
        timeResources: true,
      },
    },
  })

  const hourlyResourceTypeExists = useMemo(() => {
    return query.data?.resourceTypes?.length ? true : false
  }, [query])

  return hourlyResourceTypeExists ?? false
}
